import { render, staticRenderFns } from "./SubjectSection.vue?vue&type=template&id=4134ce1c&scoped=true&"
import script from "./SubjectSection.vue?vue&type=script&lang=js&"
export * from "./SubjectSection.vue?vue&type=script&lang=js&"
import style0 from "./SubjectSection.vue?vue&type=style&index=0&id=4134ce1c&prod&scoped=true&lang=css&"
import style1 from "./SubjectSection.vue?vue&type=style&index=1&id=4134ce1c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4134ce1c",
  null
  
)

export default component.exports